import React from 'react';

const Footer = () => {
    return (
        <div className="text-center p-4 bg-blue-600 font-bold text-white"></div>
    );
};

export default Footer;